export default __webpack_public_path__ + "static/media/left-side-background.83751411.svg";